<template>
    <div>
        <v-search>
            条件筛选
            <a-button
                type="primary"
                @click="addconfig"
                v-if="this.$route.query.systemname"
                class="fr opbuttonmt"
                style="float:right;display:inline-block"
            >添加配置</a-button>
        </v-search>
        <div v-if="this.$route.query.systemname && this.$route.query.serverip">
            <p class="pt10 pl20">
                系统名称：
                <b>{{this.$route.query.systemname}}</b>
                <span class="ml20">
                    服务器IP：
                    <b>{{this.$route.query.serverip}}</b>
                </span>
            </p>
        </div>
        <v-tablelist></v-tablelist>
        <v-dynattr :key="modalkey" :visible="visible" :record="record" action="add"></v-dynattr>
    </div>
</template>

<script>
import TableList from "./configtablelist.vue";
import Search from "./configsearch.vue";
import DynAttrs from "./components/DynAttrs.vue";

export default {
    data() {
        return {
            show: true,
            modalkey: Math.random(),
            visible: false,
            record: {
                config: '[{"id":"'+new Date().getTime()+'","key":"hystrix.%s.enabled", "value": "true"}]'
            }
        };
    },
    methods: {
        addconfig() {
            this.visible = true;
            this.modalkey = new Date().getTime();
        }
    },
    computed: {},
    components: {
        "v-tablelist": TableList,
        "v-search": Search,
        "v-dynattr": DynAttrs
    },
    beforeMount() {
        if (this.$route.path.indexOf("/zhixing") > -1) {
            this.show = false;
        }
    },
    mounted() {}
};
</script>

<style scoped>
</style>
